<template>
  <div class="md:hidden fixed bottom-0 left-0 right-0 z-50 px-6 pb-6 pointer-events-none">
    <div class="glass-morphism rounded-[32px] p-2 flex items-center justify-between pointer-events-auto shadow-2xl safe-bottom">
      
      <!-- Home -->
      <router-link to="/" class="nav-item" :class="{ 'active': $route.path === '/' }" aria-label="Accueil">
        <HomeIcon class="w-6 h-6" aria-hidden="true" />
        <span class="text-[9px] font-black uppercase mt-1">Accueil</span>
      </router-link>

      <!-- All Products / Categories -->
      <router-link to="/categorie/nuit" class="nav-item" :class="{ 'active': $route.path.startsWith('/categorie') }" aria-label="Produits et catégories">
        <Squares2X2Icon class="w-6 h-6" aria-hidden="true" />
        <span class="text-[9px] font-black uppercase mt-1">Produits</span>
      </router-link>

      <!-- Cart Button (Floating Style) -->
      <button 
        @click="cart.openCart()" 
        class="nav-item relative bg-fire-gold text-black rounded-2xl scale-110 -translate-y-2 shadow-lg shadow-fire-gold/30"
        aria-label="Voir le panier, contient {{ cart.itemCount }} articles"
      >
        <ShoppingCartIcon class="w-6 h-6" aria-hidden="true" />
        <transition name="pop">
          <span v-if="cart.itemCount > 0" class="absolute -top-1 -right-1 bg-white text-black text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center border-2 border-fire-gold" aria-hidden="true">
            {{ cart.itemCount }}
          </span>
        </transition>
      </button>

      <!-- Orders / Account -->
      <router-link to="/mes-commandes" class="nav-item" :class="{ 'active': $route.path === '/mes-commandes' }" aria-label="Mes commandes">
        <ShoppingBagIcon class="w-6 h-6" aria-hidden="true" />
        <span class="text-[9px] font-black uppercase mt-1">Commandes</span>
      </router-link>

      <!-- Profile -->
      <router-link v-if="auth.isAuthenticated" to="/checkout" class="nav-item" :class="{ 'active': $route.path === '/checkout' }" aria-label="Mon compte">
        <MapPinIcon class="w-6 h-6" aria-hidden="true" />
        <span class="text-[9px] font-black uppercase mt-1">Adresses</span>
      </router-link>
      <button v-else @click="openLogin" class="nav-item" aria-label="Se connecter">
        <UserIcon class="w-6 h-6" aria-hidden="true" />
        <span class="text-[9px] font-black uppercase mt-1">Profil</span>
      </button>

    </div>
  </div>
</template>

<script setup>
import { useCartStore } from '../stores/cart';
import { useAuthStore } from '../stores/auth';
import { 
  HomeIcon, 
  ShoppingCartIcon, 
  Squares2X2Icon, 
  ShoppingBagIcon, 
  UserIcon,
  MapPinIcon
} from '@heroicons/vue/24/solid';

const cart = useCartStore();
const auth = useAuthStore();

const openLogin = () => {
  // We can trigger the login modal from here if we expose it globally or via cart drawer
  cart.openCart(); // For now, opening cart will show login if unauth during checkout
};
</script>

<style scoped>
.glass-morphism {
  background: rgba(15, 15, 15, 0.85);
  backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.nav-item {
  @apply flex flex-col items-center justify-center flex-1 h-14 text-gray-500 transition-all duration-300 active:scale-95;
}

.nav-item.active {
  @apply text-fire-gold;
}

.safe-bottom {
  padding-bottom: env(safe-area-inset-bottom);
}

.pop-enter-active { animation: pop 0.3s cubic-bezier(0.19, 1, 0.22, 1); }
@keyframes pop {
  0% { transform: scale(0); }
  70% { transform: scale(1.3); }
  100% { transform: scale(1); }
}
</style>
